@if (groups && groups.length>0) {
  <div class="d-inline-flex mt-2 dashboard-widget-bar">
    <!-- <div class="dropdown mr-2">
    <button type="button" class="btn bg-white border dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      {{selectedWidgetType}}
    </button>
    <div class="dropdown-menu">
      <a  *ngFor="let entry of groups" class="dropdown-item" (click)="getWidgetByType(entry.name)">
        {{ entry.name }}
      </a>
    </div>
  </div> -->
  @for (entry of groups; track entry) {
    @if (this.widgetCollection && widgetsAvailable(entry)) {
      <a class="dashboard-sidebar-items" (dragstart)="getWidgetByType($event,entry)"
        draggable="true">
        <div class="img-container">
          @if (entry.imageUrl && this.widgetCollection && widgetsAvailable(entry)) {
            <img
              src="./assets/images/{{entry.imageUrl}}">
            }
          </div>
          <span>{{ entry.name }}</span>
        </a>
      }
    }
    <!-- <div class="dropdown">
    <button type="button" class="btn bg-white border dropdown-toggle" [disabled]="widgetByGroup.length==0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      Select Widget
    </button>
    <div class="dropdown-menu overflow-auto" style="max-height: 50vh;">
      <a  *ngFor="let widget of widgetByGroup;let i=index"(dragstart)="onDrag($event, widget,i)" draggable="true" class="dropdown-item" >
        {{ widget.widget_name }}
      </a>
    </div>
  </div> -->
</div>
}
@if (deletedWidgets.length>0) {
  <div class="dropdown d-inline-flex">
    <button type="button" class="btn bg-white border dropdown-toggle" [disabled]="deletedWidgets.length==0"
      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="dropMenu.classList.toggle('show')">
    Select Widget
  </button>
  <div #dropMenu id="dropdown-menu" class="dropdown-menu overflow-auto" style="max-height: 50vh;" >
    @for (widget of deletedWidgets; track widget; let i = $index) {
      <a (dragstart)="onDrag($event, widget,i)" draggable="true"
        class="dropdown-item">
        {{ widget.widget_name }}
      </a>
    }
  </div>
</div>
}